import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handlePostCommentSuccess(
  state: State,
  { discussion, comment }: Boundaries["postComment"]["success"],
): State {
  return state.map((result) =>
    result.discussion.uuid === discussion.uuid
      ? {
          ...result,
          discussion: {
            ...result.discussion,
            comments: [
              ...result.discussion.comments.filter(
                (com) => com.uuid !== `__pending__${comment.content}`,
              ),
              comment,
            ],
          },
        }
      : result,
  );
}

export { handlePostCommentSuccess };
